'use client';

import { Menu } from 'lucide-react';

import { Button } from '@ci/ui/button';
import { useSidebar } from '@ci/ui/sidebar';

export function FloatingDocumentationNavigationButton() {
  const { toggleSidebar } = useSidebar();
  return (
    <Button
      size={null}
      variant={null}
      className={
        'bg-primary fixed right-5 bottom-5 z-10 h-16! w-16! rounded-full! lg:hidden'
      }
      onClick={toggleSidebar}
    >
      <Menu className={'text-primary-foreground size-6'} />
    </Button>
  );
}
